import Routes from "@navigations/Routes";

export enum AppStateProps {
  LOADING = "loading",
  SUCCESS = "success",
  ERROR = "error",
}

export enum OnboardingScreenPlatform {
  ALL = 0,
  WEB = 1,
  MOBILE = 2,
  DESKTOP = 3,
}

export enum ThemeTokenTypes {
  ORG = "org",
  COMPANY = "company",
}

export enum OnBoardingTypes {
  pre_login = 0,
  post_login = 1,
}

export type InitialSetupScreenProps = {
  appStateReady: any;
  setInitialScreen: (route: Routes) => void;
  setAppStateReady: (appStateProps: AppStateProps) => void;
};
